import 'angular';
import AppConstants from '../gorillaboy/AppConstants';
import {DocMetadata} from '../types/DocMetadata';
import {FolderMetadata} from '../types/FolderMetadata'

interface ResourceIconService {
    getFolderIcon: (folder: FolderMetadata) => string;
    getFileIcon: (file: DocMetadata) => string;
}


angular.module('GorillaBoy.services')
    .factory('ResourceIconService', [
    '$log',
    function ResourceIconServiceFactory($log: ng.ILogService) {
        let fileTypesMap = {
            DEFAULT: {
                icon: 'resource-icon-sprite-ic_doc_generic'
            },
            WORD: {
                types: ['ms-word', 'wordprocessingml', 'msword'],
                icon: 'resource-icon-sprite-ic_docx'
            },
            IMG: {
                types: ['image'],
                icon: 'resource-icon-sprite-ic_jpg'
            },
            XLS: {
                types: ['ms-excel', 'spreadsheetml', 'msexcel'],
                icon: 'resource-icon-sprite-ic_xls'
            },
            PPT: {
                types: ['ms-powerpoint', 'presentationml', 'mspowerpoint'],
                icon: 'resource-icon-sprite-ic_ppt'
            },
            PDF: {
                types: ['application/pdf'],
                icon: 'resource-icon-sprite-ic_pdf'
            },
            TXT: {
                types: ['text/plain'],
                icon: 'resource-icon-sprite-ic_txt'
            },
            MOV: {
                types: ['video/quicktime'],
                icon: 'resource-icon-sprite-ic_mov'
            },
            MP3: {
                types: ['audio/mp3'],
                icon: 'resource-icon-sprite-ic_mp3'
            },
            MP4: {
                types: ['video/mp4'],
                icon: 'resource-icon-sprite-ic_mp4'
            },
            WAV: {
                types: ['audio/wav', 'audio/x-wav'],
                icon: 'resource-icon-sprite-ic_wav'
            },
            ZIP: {
                types: ['application/zip'],
                icon: 'resource-icon-sprite-ic_zip'
            }
        };

        function getFolderIcon(folder: FolderMetadata) {
            var folderIcon = 'resource-icon-sprite-ic_folder',
                isSharedLink = folder.SharedWithOrganization;

            if (isSharedLink) {
                folderIcon = 'resource-icon-sprite-ic_folder_share';
            }

            return folderIcon;
        };

        function getFileIcon(doc: DocMetadata) {
            var fileIcon = fileTypesMap.DEFAULT.icon,
                fileType = doc.VersionMetadata.ContentType.toLowerCase(),
                isLocked = !!(doc.CheckoutInfo),
                isSharedLink = doc.SharedAnonymously || doc.SharedWithOrganization;

            if (fileType) {
                if (fileTypesMap.WORD.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.WORD.icon;
                } else if (fileTypesMap.IMG.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.IMG.icon;
                } else if (fileTypesMap.ZIP.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.ZIP.icon;
                } else if (fileTypesMap.MP3.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.MP3.icon;
                } else if (fileTypesMap.MP4.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.MP4.icon;
                } else if (fileTypesMap.WAV.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.WAV.icon;
                } else if (fileTypesMap.MOV.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.MOV.icon;
                } else if (fileTypesMap.XLS.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.XLS.icon;
                } else if (fileTypesMap.PPT.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.PPT.icon;
                } else if (fileTypesMap.PDF.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.PDF.icon;
                } else if (fileTypesMap.TXT.types.some(type=>fileType.indexOf(type)!== -1)) {
                    fileIcon = fileTypesMap.TXT.icon;
                }
            }

            // If file is locked/shared, overwrite the normal icon
            if (isLocked && isSharedLink) {
                fileIcon = 'resource-icon-sprite-ic_doc_shared_locked';
            } else if (isLocked) {
                fileIcon = 'resource-icon-sprite-ic_doc_locked';
            } else if (isSharedLink) {
                fileIcon = 'resource-icon-sprite-ic_doc_shared';
            }

            return fileIcon;
        };

        let service: ResourceIconService = {
            getFolderIcon: getFolderIcon,
            getFileIcon: getFileIcon
        };

        return service;
    }]);

export default ResourceIconService;
